'use client';

import { Skeleton } from '@/shared/components';
import { NAMESPACE, useLang } from '@/hooks/use-lang';

const aiSkeletonStyle = {
  background:
    'linear-gradient(90deg, rgba(255, 229, 197, 0.99) 0, rgba(255, 229, 197, 0.99) 4px, #ffefd9 4px, #ffe8cc 16%, #fff 34%)',
  borderBottom: '1px solid #E5E5E5',
};

export default function AiSearchSkeleton() {
  const { t } = useLang(NAMESPACE.search);

  return (
    <div className="flex flex-col w-full">
      <div
        role="status"
        className="px-5 py-3 text-sm font-medium text-[#7a4b00] bg-[#fff7ea] border-b border-[#f6d5ad]"
      >
        {t('ai.recommendation.loading')}
      </div>
      {Array.from({ length: 2 }).map((_, index) => (
        <div
          key={index}
          aria-label="AI search result loading placeholder"
          className="relative flex sm:flex-col w-full min-h-[132px] py-5"
          style={aiSkeletonStyle}
        >
          <div
            aria-hidden="true"
            className="absolute pointer-events-none"
            style={{
              inset: '0 auto 0 0',
              width: '4px',
              height: 'auto',
              background: 'linear-gradient(180deg, #ffbf66 0%, #ff9548 100%)',
            }}
          />
          <div className="ml-5 flex-shrink-0">
            <Skeleton width="114px" height="114px" rows={1} className="rounded" />
          </div>
          <div className="flex flex-col flex-1 ml-9 mr-6 sm:mx-5 sm:mt-4">
            <div className="flex sm:flex-col gap-x-[60px] gap-y-3 pr-[150px] sm:pr-0">
              <Skeleton width="130px" height="22px" rows={1} />
              <Skeleton width="180px" height="22px" rows={1} />
            </div>
            <Skeleton
              rows={2}
              width={['70%', '22%']}
              height={['28px', '28px']}
              className="flex flex-col my-4"
              gap={[8, 0]}
            />
            <Skeleton width="150px" height="22px" rows={1} />
          </div>
          <span className="absolute top-[18px] right-0 px-[10px] py-1 rounded-full bg-white text-[#7a4b00] text-[0.8rem] font-bold border-solid border-[#ffb25773]">
            {t('suggested.for.you')}
          </span>
          <div className="absolute right-4 bottom-5 w-[170px] sm:static sm:ml-5 sm:mt-4">
            <Skeleton width="170px" height="40px" rows={1} />
          </div>
        </div>
      ))}
    </div>
  );
}
